export default __webpack_public_path__ + "static/media/faceta_icon_face_statistics.c52f34f8.svg";